import { CommonModule, DatePipe } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AddPaymentInfoComponent } from '@app/components/add-payment-info/add-payment-info.component';
import { CommunicationPreferencesComponent } from '@app/components/communication-preferences/communication-preferences.component';
import { EditPaymentInfoComponent } from '@app/components/edit-payment-info/edit-payment-info.component';
import { PaymentListComponent } from '@app/components/payment-list/payment-list.component';
import { EditTravelPartyComponent } from '@components/edit-travel-party/edit-travel-party.component';
import { ConfirmLinkTicketsComponent } from '@components/link-ticket/confirm-link-tickets/confirm-link-tickets.component';
import { RegisteredLinkTicketsComponent } from '@components/link-ticket/registered-link-tickets/registered-link-tickets.component';
import { RegistrationLinkTicketsComponent } from '@components/link-ticket/registration-link-tickets/registration-link-tickets.component';
import { UpdatePasswordComponent } from '@components/update-password/update-password.component';
import { FormFieldsModule } from '@upr-web-primer/form-fields';
import { FtcModule } from '@upr-web-primer/ftc';
import { GdsCalendarModule } from '@upr-web-primer/gds-calendar';
import { GoogleRecaptchaModule } from '@upr-web-primer/google-recaptcha';
import { InheritStyleModule } from '@upr-web-primer/inherit-style';
import { LocaleModule } from '@upr-web-primer/locale';
import { ModalModule } from '@upr-web-primer/modal';
import { MsUtilsModule } from '@upr-web-primer/ms-utils';
import { UprSvgModule } from '@upr-web-primer/svg';
import { TcmAnchorModule } from '@upr-web-primer/tcm-anchor';
import { TcmImageModule } from '@upr-web-primer/tcm-image';
import { TcmPictureModule } from '@upr-web-primer/tcm-picture';
import { TooltipModule } from '@upr-web-primer/tooltip';
import { UrlInfoModule } from '@upr-web-primer/url-info';
import { WindowModule } from '@upr-web-primer/window';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { InquiryConfirmComponent } from '../account/inquiry-confirm/inquiry-confirm.component';
import { SharedModule } from '../shared/shared-module';
import { TimeFormatPipe } from '../shared/time.pipe';
import { CartNavigationComponent } from './cart-navigation/cart-navigation.component';
import { InquiryWebFormComponent } from './inquiry-web-form/inquiry-web-form.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { LostFoundConfirmComponent } from './lost-found-confirm/lost-found-confirm.component';
import { LostFoundWebFormComponent } from './lost-found-web-form/lost-found-web-form.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SigninComponent } from './signin/signin.component';
import { UnsubscribeEmailComponent } from './unsubscribe-email/unsubscribe-email.component';
@NgModule({
  imports: [
    CommonModule,
    WindowModule,
    LocaleModule,
    UrlInfoModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TcmAnchorModule,
    TcmImageModule,
    TcmPictureModule,
    ModalModule,
    GoogleRecaptchaModule,
    TooltipModule,
    FormsModule,
    MsUtilsModule,
    FormFieldsModule,
    InheritStyleModule,
    UprSvgModule,
    SharedModule,
    ZXingScannerModule,
    FtcModule,
    GdsCalendarModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  declarations: [
    TimeFormatPipe,
    LoginComponent,
    UpdatePasswordComponent,
    PageNotFoundComponent,
    EditTravelPartyComponent,
    RegistrationLinkTicketsComponent,
    ConfirmLinkTicketsComponent,
    RegisteredLinkTicketsComponent,
    UnsubscribeEmailComponent,
    CommunicationPreferencesComponent,
    InquiryWebFormComponent,
    CartNavigationComponent,
    LostFoundWebFormComponent,
    PaymentListComponent,
    AddPaymentInfoComponent,
    EditPaymentInfoComponent,
    LogoutComponent,
    SigninComponent,
    InquiryConfirmComponent,
    LostFoundConfirmComponent,
  ],
  exports: [TimeFormatPipe],
  providers: [Title, DatePipe],
})
export class AccountModule {}
